export default function lessons({ context }) {

  const devUrl = 'https://staging18.staging.gb.ru/api/v2/'
  const prodUrl = 'https://gb.ru/api/v2/'

  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
      async autoTaskStatus(resourceId) {
        try {
            const { data } = await axios.get(
                `${baseUrl}lessons/new/${resourceId}/auto_tasks_status`
            )

            return data
        }  catch (e) {
            console.error(e)
        }
      },

    async markHomework(resourceId) {
      try {
        await context.$axios.post(
          `${baseUrl}lessons/new/${resourceId}/mark_homework_seen`
        )
      } catch (e) {
        console.error(e)
      }
    },

   async getCourseProgramByLessonId(lessonId) {
      try {
        const { data } = await context.$axios.get(`${baseUrl}lessons/new/${lessonId}/left_aside_data`)

        return data
      } catch (e) {
        console.warn(e)
      }
    },

    async getLesson(id) {
      try {
        const { data } = await context.$axios.get(`${baseUrl}lessons/new/${id}`)

        return data
      } catch (e) {
        console.error(e)
      }
    },

    async getPlaylist(id) {
      try {
        const { data } = await context.$axios.get(`${baseUrl}lessons/new/${id}/playlist`)

        return data
      } catch (e) {
        console.error(e)
      }
    },

    async getChat(url) {
      try {
        const { data } = await context.$axios.get(url)

        return data
      } catch (e) {
        console.error(e)

        return []
      }
    },

    async getFeedbackForms(lessonId) {
      try {
        const { data } = await context.$axios.get(`${baseUrl}lessons/new/${lessonId}/feedback_forms`)

        return data
      } catch (e) {
        console.error(e)
      }
    },

    async sendFeedbackForm(lessonForm, comment, formId, lessonId){
      const formData = {
        feedback_form_id: formId,
        comment: comment || null,
        feedback_form_answers: lessonForm
      }
      try {
        const { data } = await context.$axios.post(`${baseUrl}lessons/new/${lessonId}/feedbacks`, formData)

        return data
      } catch (e) {
        console.error(e)
      }
    }
  }
}
